export default __webpack_public_path__ + "images/5125b085b42f54c56847289c140b38e2.png";